let visible = false;
const listeners = new Set();
function notify() {
    for (const listener of listeners)
        listener();
}
export const webNotificationBannerStore = {
    show: () => {
        if (visible)
            return;
        visible = true;
        notify();
    },
    hide: () => {
        if (!visible)
            return;
        visible = false;
        notify();
    },
    subscribe: (listener) => {
        listeners.add(listener);
        return () => {
            listeners.delete(listener);
        };
    },
    getSnapshot: () => visible,
};
//# sourceMappingURL=webNotificationBannerStore.js.map